import { render, staticRenderFns } from "./SemRegistros.vue?vue&type=template&id=528f982b&scoped=true&"
import script from "./SemRegistros.vue?vue&type=script&lang=js&"
export * from "./SemRegistros.vue?vue&type=script&lang=js&"
import style0 from "./SemRegistros.vue?vue&type=style&index=0&id=528f982b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "528f982b",
  null
  
)

export default component.exports